var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download"},[_c('div',{staticClass:"download__btn",on:{"click":_vm.downloadProject}},[_vm._v("匯出專案")]),_c('div',{staticClass:"download__btn btn--example",on:{"click":_vm.downloadExample}},[_vm._v(" 匯出範例 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }